import React, { forwardRef } from 'react'
// import Textarea from 'react-textarea-autosize'
import classnames from 'classnames'
import { withFormValue } from '@bigfishtv/react-forms'

import RadioGroup from '@bigfishtv/cockpit/es5/components/input/RadioGroupInput'
import CheckboxGroup from '@bigfishtv/cockpit/es5/components/input/CheckboxGroup'
import Checkbox from '@bigfishtv/cockpit/es/components/input/Checkbox'

const requiredAsterisk = <span className="color-error">*</span>

const Field = withFormValue(props => {
  const { label, placeholder, type = 'text', text, required, options, className, inline, inputRef } = props
  const { formValue } = props
  const errors = formValue.errorList
  const inputClassName = errors.length ? 'error' : ''
  return (
    <div className={classnames(className, 'field')}>
      {label && (
        <label>
          {label} {required && requiredAsterisk}
        </label>
      )}
      {type == 'checkbox' && (
        <div>
          <Checkbox text={text} value={formValue.value} onChange={value => formValue.update(value)} />
        </div>
      )}
      {type == 'checkboxes' && (
        <CheckboxGroup
          value={formValue.value}
          onChange={value => formValue.update(value)}
          options={options}
          inline={inline}
        />
      )}
      {type == 'radiobuttons' && (
        <RadioGroup
          value={formValue.value}
          onChange={value => formValue.update(value)}
          options={options}
          inline={inline}
        />
      )}
      {/*type == 'textarea' && (
                <Textarea
                minRows={3}
                value={formValue.value || ''}
                placeholder={placeholder}
                onChange={event => formValue.update(event.target.value)}
                className={inputClassName}
                />
            )*/}
      {(type === 'text' || type === 'tel' || type === 'number' || type === 'email') && (
        <input
          ref={inputRef}
          type={type}
          value={formValue.value || ''}
          placeholder={placeholder}
          onChange={event => formValue.update(event.target.value)}
          className={inputClassName}
        />
      )}
      {errors.map((error, i) => (
        <div key={i} className="form-message error">
          {error.message}
        </div>
      ))}
    </div>
  )
})

const FieldForwardRef = forwardRef((props, ref) => <Field {...props} inputRef={ref} />)

export default FieldForwardRef
